import React, { Component } from "react";
import GithubCommitActivity from "../commit-activity/index";
import GithubCode from "../github-code/index";
import GithubOverview from "../github-overview/index";
import "../index.css";

class GithubStatsDesktop extends Component {
  render() {
    return (
      <section id="github-stats-section">
        <div className="row mb-5 mt-4 container-size">
          <div className="col-4">
            <GithubCommitActivity />
          </div>
          <div className="col-4">
            <GithubCode />
          </div>
          <div className="col-4">
            <GithubOverview />
          </div>
        </div>
      </section>
    );
  }
}

export default GithubStatsDesktop;
